import { render, staticRenderFns } from "./AbandonedCheckoutsRecovery.vue?vue&type=template&id=974363d2&"
import script from "./AbandonedCheckoutsRecovery.vue?vue&type=script&lang=js&"
export * from "./AbandonedCheckoutsRecovery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports